import React, { useState } from "react"
import { IconButton, InputAdornment } from "@material-ui/core"
import { Visibility, VisibilityOff } from "@material-ui/icons"
import FieldTextarea from "./FieldTextarea"

function getViewModel(showPassword) {
  if (showPassword) {
    return { type: "text", Icon: Visibility }
  }
  return { type: "password", Icon: VisibilityOff }
}

export default function FieldPassword(props) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword(!showPassword)

  const handleMouseDownPassword = (event) => event.preventDefault()

  const { type, Icon } = getViewModel(showPassword)

  const EndAdornment = (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
      >
        <Icon color="primary" />
      </IconButton>
    </InputAdornment>
  )

  return (
    <FieldTextarea
      {...props}
      type={type}
      InputProps={{
        endAdornment: EndAdornment,
        autoComplete: "current-password"
      }}
    />
  )
}
